module.exports = __webpack_public_path__ + "def5b9a1637f2147298bc66157f01dc1.glb";